import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import InfoItem from 'components/PackageBuilder/Results/shared/InfoItem'
import { CustomerSegmentationContext } from 'components/PackageBuilder/CreateSteps/CustomerSegmentation/CustomerSegmentationContext'
import { useCustomSegmentationInfo } from './useCustomSegmentationInfo'


function CustomerSegmentationInfo({ setCustomerModalOpen }) {
  const state = useContext(CustomerSegmentationContext)
  const { customSegmentationInfo } = useCustomSegmentationInfo({ state, setCustomerModalOpen })

  return customSegmentationInfo.map((item) => (
    <InfoItem key={item.title} info={item} />
  ))
}

CustomerSegmentationInfo.propTypes = {
  setCustomerModalOpen: PropTypes.func.isRequired,
}

export default CustomerSegmentationInfo